module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/angle-right-20020d0de53ee215924d032f6976a844.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/angle-right.svg
// module id = +Qzx
// module chunks = 24